/**
 * Routines to convert from generated types to friendlier ones.
 */

import {LaunchAgent} from '../../generated/graphql';
import {Agent, AgentStatus} from './utilTypes';

export const convertAgent = (agent: LaunchAgent): Agent => {
  const {id, name, createdAt, agentStatus, hostname, runQueues, stopPolling} =
    agent;
  return {
    id,
    name,
    createdAt: createdAt.toString(),
    agentStatus: agentStatus as AgentStatus,
    hostname,
    runQueues,
    stopPolling,
  };
};
